/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_Kind_TeamInputs */



/**
* | output |
* | --- |
* | "Team meetings" |
*
* @param {Meetings_Kind_TeamInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_kind_team = /** @type {((inputs?: Meetings_Kind_TeamInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_Kind_TeamInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Teammeetings")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Réunions d'équipe")
	return /** @type {LocalizedString} */ ("Team meetings")
});